(() => {
  const positiveInteger = (value) => {
    const parsed = Number.parseInt(value || "0", 10);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : 0;
  };

  const initialise = (root) => {
    if (root.dataset.ttcLimitFallbackInitialised === "true") return;

    let variants = [];
    try {
      variants = JSON.parse(root.querySelector("[data-brewstack-variants]")?.textContent || "[]");
    } catch {
      return;
    }

    const section = document.getElementById(`shopify-section-${root.dataset.sectionId}`) || document;
    const alert = root.querySelector("[data-brewstack-limit-alert]");
    let currentVariantId = "";

    const selectedVariantId = () => {
      const formVariant = section.querySelector('form[action*="/cart/add"] [name="id"]');
      const urlVariant = new URL(window.location.href).searchParams.get("variant");
      return String(formVariant?.value || urlVariant || variants[0]?.id || "");
    };

    const update = () => {
      const id = selectedVariantId();
      if (!id || id === currentVariantId) return;
      currentVariantId = id;

      const variant = variants.find((item) => String(item.id) === id) || variants[0];
      const productLimit = positiveInteger(root.dataset.productLimit);
      const variantLimit = positiveInteger(variant?.max);
      const limit = productLimit || variantLimit;

      if (alert) {
        alert.hidden = !limit;
        alert.textContent = limit
          ? (variantLimit ? root.dataset.optionLimitMessage : root.dataset.productLimitMessage)
              .replaceAll("{limit}", String(limit))
          : "";
      }

      for (const input of section.querySelectorAll('input[name="quantity"]')) {
        if (limit) {
          input.dataset.ttcPurchaseLimit = String(limit);
          input.max = String(limit);
        } else {
          delete input.dataset.ttcPurchaseLimit;
          input.removeAttribute("max");
        }
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    };

    root.dataset.ttcLimitFallbackInitialised = "true";
    section.addEventListener("change", () => window.setTimeout(() => {
      currentVariantId = "";
      update();
    }, 0));
    document.addEventListener("variant:change", () => {
      currentVariantId = "";
      update();
    });
    document.addEventListener("product:variant-change", () => {
      currentVariantId = "";
      update();
    });
    update();
  };

  const initialiseAll = () => {
    document.querySelectorAll("[data-brewstack-purchase-controls]").forEach(initialise);
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initialiseAll);
  else initialiseAll();
  document.addEventListener("shopify:section:load", initialiseAll);
})();
